/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

import PrtinerList from './PrinterList'
import PrinterProfile from './PrinterProfile'

import Spinner from 'components/Spinner.js';


export default class PrinterContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSpinner: true,
      content: null,
      id: null,
      data: []
    };
  }

  componentDidMount() {
    this.reset();
  }

  setId = (id) => {
    this.setState({
      content: <PrinterProfile printerId={id} reset={this.reset} />,
      showSpinner: false,
    });
  }

  reset = () => {
    this.setState({ 
      content: <PrtinerList setId={this.setId} />,
      showSpinner: false,
    });
  }

  render ()
  {
    return (
      <Fragment>
        <a href='#' onClick={this.reset}>Print List</a>
        <div>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.content }
        </div>
      </Fragment>
    );
  }
}
